// import React from "react";

// const plans = [
//   {
//     name: "Play & Dine Starter",
//     cycle: "Monthly",
//     price: "SAR2,999",
//     note: "Perfect for new venues starting their digital journey",
//     featured: false,
//     perks: [
//       "Up to 10 game tables",
//       "Basic member management",
//       "Inventory tracking",
//       "2 staff accounts",
//       "Email support",
//       "Monthly reports",
//       "Basic analytics",
//     ],
//   },
//   {
//     name: "Play & Dine Pro",
//     cycle: "Yearly",
//     price: "SAR29,990",
//     note: "Ideal for growing entertainment venues",
//     featured: true,
//     perks: [
//       "Unlimited game tables",
//       "Advanced member management",
//       "Full inventory system",
//       "Unlimited staff accounts",
//       "Priority 24/7 support",
//       "Weekly reports",
//       "Advanced analytics",
//       "Payment gateway integration",
//       "Kitchen display system",
//       "Mobile app access",
//     ],
//   },
//   {
//     name: "Play & Dine Elite",
//     cycle: "2 Year",
//     price: "SAR49,990",
//     note: "Premium solution for established chains",
//     featured: false,
//     perks: [
//       "Everything in Pro +",
//       "Multi-location management",
//       "API access",
//       "Custom integrations",
//       "Dedicated account manager",
//       "Advanced security features",
//       "Data analytics dashboard",
//       "Staff training included",
//       "Priority feature requests",
//       "Loyalty program system",
//       "Save 40% vs monthly",
//       "White-label options",
//     ],
//   },
// ];

// export default function PricingSection() {
//   return (
//     <section id="pricing" className="bg-white py-16">
//       <div className="max-w-6xl mx-auto px-4 md:px-8">
//         <div className="text-center mb-10">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-900">
//             Plans That Fit Your Business
//           </h2>
//           <p className="mt-2 text-sm md:text-base text-slate-500 max-w-lg mx-auto">
//             Choose the perfect plan for your venue. All plans include 14 days <br/> free trial.
//           </p>
//         </div>

//         <div className="mt-20 grid grid-cols-1 lg:grid-cols-3 gap-6 items-center">
//           {plans.map((p) => (
//             <div
//               key={p.name}
//               className={[
//                 "rounded-2xl border p-6 shadow-md ",
//                 p.featured ? "border-[#7533AF] ring-1 ring-[#7533AF]/30 py-6 h-[110%]" : "border-slate-200 bg-gray-50 h-[100%]",
//               ].join(" ")}
//             >
//               {p.featured && (
//                 <div className="text-center text-xs text-[#7533AF] font-semibold mb-3">⭐</div>
//               )}

//               <div className="items-baseline justify-between">
//                 <h3 className="font-bold text-slate-900">{p.name}</h3>
//                 <span className="text-xs text-slate-500">{p.cycle}</span>
//               </div>

//               <div className="mt-3 text-2xl font-bold text-[#7533AF]">{p.price}</div>

//               <p className="mt-2 text-xs text-slate-500">{p.note}</p>

//               <div className="mt-5">
//                 <button
//                   className={[
//                     "w-full rounded-lg px-5 py-2 text-sm font-semibold shadow-sm",
//                     p.featured
//                       ? "bg-[#7533AF] text-white hover:opacity-90"
//                       : "border border-[#7533AF] text-[#7533AF] hover:bg-[#7533AF]/10",
//                   ].join(" ")}
//                 >
//                   Start Free Trial
//                 </button>
//               </div>

//               <ul className="mt-6 space-y-2 text-xs text-slate-600">
//                 {p.perks.map((x) => (
//                   <li key={x} className="flex gap-2">
//                     <span className="text-[#7533AF] font-extrabold">✓</span>
//                     <span>{x}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }


import React from "react";

const plans = [
  {
    name: "Play & Dine Starter",
    cycle: "Monthly",
    price: "SAR2,999",
    note: "Perfect for new venues starting their digital journey",
    featured: false,
    perks: [
      "Up to 10 game tables",
      "Basic member management",
      "Inventory tracking",
      "2 staff accounts",
      "Email support",
      "Monthly reports",
      "Basic analytics",
    ],
  },
  {
    name: "Play & Dine Pro",
    cycle: "Yearly",
    price: "SAR29,990",
    note: "Ideal for growing entertainment venues",
    featured: true,
    perks: [
      "Unlimited game tables",
      "Advanced member management",
      "Full inventory system",
      "Unlimited staff accounts",
      "Priority 24/7 support",
      "Weekly reports",
      "Advanced analytics",
      "Payment gateway integration",
      "Kitchen display system",
      "Mobile app access",
      "Save 17% vs monthly"
    ],
  },
  {
    name: "Play & Dine Elite",
    cycle: "2 Year",
    price: "SAR49,990",
    note: "Premium solution for established chains",
    featured: false,
    perks: [
      "Everything in Pro +",
      "Multi-location management",
      "API access",
      "Custom integrations",
      "Dedicated account manager",
      "Advanced security features",
      "Data analytics dashboard",
      "Staff training included",
      "Priority feature requests",
      "Loyalty program system",
      "Save 40% vs monthly",
      "White-label options",
    ],
  },
];

export default function PricingSection() {
  return (
    <section id="pricing" className="bg-white py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900">
            Plans That Fit Your Business
          </h2>
          <p className="mt-2 text-sm md:text-base text-slate-500 max-w-lg mx-auto">
            Choose the perfect plan for your venue. All plans include 14 days{" "}
            <br className="hidden sm:block" /> free trial.
          </p>
        </div>

        {/* ✅ Responsive Grid */}
        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 items-stretch">
          {plans.map((p) => (
            <div
              key={p.name}
              className={[
                "rounded-2xl border shadow-md p-6 flex flex-col",
                p.featured
                  ? "border-[#7533AF] ring-1 ring-[#7533AF]/30 bg-white lg:-translate-y-5 lg:h-[110%]"
                  : "border-slate-200 bg-gray-50",
              ].join(" ")}
            >
              {p.featured && (
                <div className="text-center text-xs text-[#7533AF] font-semibold mb-3">
                  ⭐
                </div>
              )}

              {/* Header */}
              <div className="flex items-baseline justify-between gap-3">
                <h3 className="font-bold text-slate-900">{p.name}</h3>
                <span className="text-xs text-slate-500 whitespace-nowrap">
                  {p.cycle}
                </span>
              </div>

              <div className="mt-3 text-2xl font-bold text-[#7533AF]">
                {p.price}
              </div>

              <p className="mt-2 text-xs text-slate-500">{p.note}</p>

              {/* CTA */}
              <div className="mt-5">
                <button
                  className={[
                    "w-full rounded-lg px-5 py-2 text-sm font-semibold shadow-sm",
                    p.featured
                      ? "bg-[#7533AF] text-white hover:opacity-90"
                      : "border border-[#7533AF] text-[#7533AF] hover:bg-[#7533AF]/10",
                  ].join(" ")}
                >
                  Start Free Trial
                </button>
              </div>

              {/* List */}
              <ul className="mt-6 space-y-2 text-xs text-slate-600 flex-1">
                {p.perks.map((x) => (
                  <li key={x} className="flex gap-2">
                    <span className="text-[#7533AF] font-extrabold">✓</span>
                    <span>{x}</span>
                  </li>
                ))}
              </ul>

              {/* Optional small footer line like screenshot */}
              {/* {p.featured && (
                <div className="mt-4 text-[11px] text-slate-500">
                  Save 17% vs monthly
                </div>
              )} */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
